
<!-- content included in DomainPopup component -->
<div class="cmp-domain-popup-transfer ws-typography q-px-xl q-py-lg">
  <h6>
    {{ $t('domain_checker.transfer.title') }}
    <span class="text-green">{{ priceLabel }}</span>
  </h6>

  <p>
    <small>{{ transKey }}</small>
  </p>

  <div v-if="!shouldLogin && isEppCodeRequired" class="q-mt-xl">
    <ws-input
      v-model="eppCodeValue"
      :label="$t('domain_checker.transfer.input_placeholder')"
      path="transfer.eppCodeValue"
    />
    <ws-message path="properties.domain"></ws-message>
  </div>

  <div class="buttons-section row justify-between q-mt-xl">
    <!-- TODO: loggin in never triggered, why is it here? -->
    <ws-button
      v-if="shouldLogin"
      class="cy-add-transfer-button"
      :type="WsButtonEnum.Type.PRIMARY"
      @click="triggerLogin"
    >
      {{ $t('login.hf_template.to_login') }}
    </ws-button>

    <ws-button
      v-if="!shouldLogin"
      :loading="loading"
      :disable="loading"
      :type="WsButtonEnum.Type.PRIMARY"
      :size="WsButtonEnum.Size.MEDIUM"
      class="cy-add-transfer-button"
      @click="addTransferToCart"
    >
      {{ $t('domain_checker.transfer.buy_button') }}
    </ws-button>

    <ws-button
      :href="transferUrl"
      :type="WsButtonEnum.Type.SECONDARY"
      :size="WsButtonEnum.Size.MEDIUM"
      :element="WsButtonEnum.Element.A"
      target-blank
      icon="support"
    >
      {{ $t('domain_checker.transfer.about_link_text') }}
    </ws-button>
  </div>
</div>
